// InputField.tsx — для использования с <Field component={...} />
import React, { FC, useState } from 'react'
import { FieldProps } from 'formik'
import Select, { SelectProps } from '../redesign/select/Select'
import { SelectOption } from '../redesign/select/Option'

type SelectFieldProps = Omit<SelectProps, 'onChange' | 'onBlur' | 'error'> & FieldProps

const SelectField: FC<SelectFieldProps> = ({ field, form, ...props }) => {
  const [value, setValue] = useState<SelectOption | null>(null)

  const handleSelect = (value: SelectOption) => {
    form.setFieldValue(field.name, value?.value)

    setValue(value)
    props.onSelect?.(value)
  }

  const meta = {
    touched: form.touched[field.name] as boolean,
    error: form.errors[field.name] as string,
  }

  return (
    <Select
      {...field}
      {...props}
      value={value}
      error={meta.touched && meta.error ? meta.error : ''}
      onSelect={handleSelect}
    />
  )
}

export default SelectField
